import { preparePreviewPagination } from '../../features/result-preview/result-preview-actions.js';
import { logDocumentQuickview } from '../../features/result-preview/result-preview-analytics-actions.js';
import { buildResultPreviewRequest } from '../../features/result-preview/result-preview-request-builder.js';
import { searchReducer as search } from '../../features/search/search-slice.js';
import { loadReducerError } from '../../utils/errors.js';
import { buildCoreQuickview, } from '../core/quickview/headless-core-quickview.js';
/**
 * Creates a `Quickview` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `Quickview` properties.
 * @returns A `Quickview` controller instance.
 *
 * @group Controllers
 * @category Quickview
 */
export function buildQuickview(engine, props) {
    if (!loadSearchQuickviewReducers(engine)) {
        throw loadReducerError;
    }
    const { dispatch } = engine;
    const getState = () => engine.state;
    const getResults = () => getState().search.results;
    const fetchResultContentCallback = () => {
        engine.dispatch(logDocumentQuickview(props.options.result));
    };
    const path = '/html';
    const core = buildCoreQuickview(engine, props, buildResultPreviewRequest, path, fetchResultContentCallback);
    dispatch(preparePreviewPagination({ results: getResults() }));
    return {
        ...core,
        get state() {
            return {
                ...core.state,
                currentResult: getResults().findIndex((r) => r.uniqueId === core.state.currentResultUniqueId) + 1,
                totalResults: getResults().length,
            };
        },
    };
}
function loadSearchQuickviewReducers(engine) {
    engine.addReducers({ search });
    return true;
}
